var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(58 8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.924,28.649a4.15,4.15,0,1,0-7.432,3.228L4.234,34.136,3.186,33.088l-.754.754L3.479,34.89l-.838.839L1.09,34.178,0,35.268l2.641,2.641,4.972-4.973a4.149,4.149,0,0,0,6.311-4.286Zm-1.629,1.268a2.5,2.5,0,0,1-1.507,1.831,2.5,2.5,0,0,1-1.414.137,2.495,2.495,0,0,1-1.831-1.507,2.5,2.5,0,0,1-.137-1.413,2.5,2.5,0,0,1,1.507-1.831A2.5,2.5,0,0,1,10.327,27,2.5,2.5,0,0,1,12.158,28.5,2.5,2.5,0,0,1,12.295,29.918Z",
    transform: "translate(61 -13.292)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPass);
export default __webpack_public_path__ + "static/media/icon_pass.7f2532c42e7bbb6b9dd51ca850aceb40.svg";
export { ForwardRef as ReactComponent };